import { type ReactNode } from "react";
import { CircularProgress, Stack } from "@mui/material";
import { useAppSelector } from "@/store/hooks";
import { useGetMeQuery } from "@/api/authApi";
import authConfig from "@/config/auth";

type AuthContextProps = {
  children: ReactNode;
};

function AuthContext({ children }: AuthContextProps) {
  const { user } = useAppSelector((state) => state.auth);
  const token = localStorage.getItem(authConfig.storageTokenKeyName);

  const { isLoading } = useGetMeQuery(undefined, {
    skip: !token,
  });

  if (token && isLoading && !user) {
    return (
      <Stack
        alignItems="center"
        justifyContent="center"
        sx={{ minHeight: "100vh" }}
      >
        <CircularProgress />
      </Stack>
    );
  }

  return <>{children}</>;
}
export default AuthContext;
